// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3ySaH","content":"styles_content__1eksV","checkbox":"styles_checkbox__2mg3d","checkboxLabel":"styles_checkboxLabel__1i-TF"};